import { DocumentFilesReply } from '../dtos/DocumentFilesReply';
import { DocumentFile } from '../models/DocumentFile';
import { mapDocumentFileDtoToModel } from './mapDocumentFileDtoToModel';

export const transformDocumentFilesReply = (
  dto: DocumentFilesReply,
): DocumentFile[] => {
  return dto.files.map(mapDocumentFileDtoToModel);
};
